import axios from "@/axios.js";

let hoursRenderedPreloadPromise = null;

export default {
  preloadHoursRenderedData({ state, commit, dispatch }, options) {
    const force = options && options.force;
    if (state.hoursRenderedDataLoaded && !force) return Promise.resolve();
    if (hoursRenderedPreloadPromise && !force) {
      return hoursRenderedPreloadPromise;
    }

    commit("SET_HOURS_RENDERED_DATA_LOADING", true);
    commit("SET_HOURS_RENDERED_DATA_ERROR", null);

    const requests = [
      ["overtime types", dispatch("lookup/getAllOvertimeType", null, { root: true })],
      ["periods", dispatch("lookup/getAllPeriodLookup", null, { root: true })],
      [
        "payroll types",
        dispatch("lookup/getAllCreatePayrollTypeLookup", null, { root: true }),
      ],
      ["earning types", dispatch("lookup/getAllEarningsType", null, { root: true })],
      [
        "deduction types",
        dispatch("lookup/getAllDeductionsType", null, { root: true }),
      ],
      ["loan categories", dispatch("lookup/getAllLoanCategory", null, { root: true })],
      [
        "loan sub-categories",
        dispatch("lookup/getAllLoanSubCategory", null, { root: true }),
      ],
      ["payroll periods", dispatch("getAllCreatePayroll")],
      ["overtime", dispatch("getAllOvertime")],
      ["earnings", dispatch("getAllEarnings")],
      ["deductions", dispatch("getAllDeductions")],
      ["loans", dispatch("getAllLoans")],
    ];

    hoursRenderedPreloadPromise = Promise.all(
      requests.map(([name, request]) =>
        request.then(
          () => ({ name, loaded: true }),
          () => ({ name, loaded: false })
        )
      )
    ).then((results) => {
      const failed = results
        .filter((result) => !result.loaded)
        .map((result) => result.name);

      commit("SET_HOURS_RENDERED_DATA_LOADED", true);
      commit("SET_HOURS_RENDERED_DATA_LOADING", false);
      commit(
        "SET_HOURS_RENDERED_DATA_ERROR",
        failed.length
          ? `Some data could not be loaded: ${failed.join(", ")}.`
          : null
      );
      hoursRenderedPreloadPromise = null;
      return results;
    });

    return hoursRenderedPreloadPromise;
  },
  ProcessUploadedData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/payroll/processupload", {
          params: {
            payrollId: payload.payrollId,
            paymentModeId: payload.paymentModeId,
            empStatusId: payload.empStatusId,
            userId: payload.processedBy,
          },
        })
        .then((response) => {
          commit("TEMP_TO_LIVE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  ProcessPayroll({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "/api/payroll/processpayroll",
          {
            params: {
              payrollId: payload.payrollId,
              paymentModeId: payload.paymentModeId,
              periodId: payload.periodId,
              monthId: payload.monthId,
              cutOffStartDate: payload.cutOffStartDate,
              cutOffEndDate: payload.cutOffEndDate,
              calendarYear: payload.calendarYear,
              tenantsId: payload.tenantsId,
              roundOff: payload.roundOff,
              userId: payload.processedBy,
            },
          },
          payload.config
        )
        .then((response) => {
          commit("PROCESS_PAYROLL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  ClosedPayroll({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/payroll/closedpayroll", {
          params: {
            payrollId: payload.payrollId,
            dateClosed: payload.dateClosed,
            userId: payload.processedBy,
          },
        })
        .then((response) => {
          commit("CLOSED_PAYROLL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GenerateReports({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/reports/generatereports", payload)
        .then((response) => {
          commit("GENERATE_REPORTS", response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addCreatePayroll({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/payroll/createpayroll", item)
        .then((response) => {
          commit(
            "ADD_CREATEPAYROLL",
            Object.assign(item, {
              createPayrollId: response.data.data.createPayrollId,
            })
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateCreatePayroll({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/payroll/createpayroll", item)
        .then((response) => {
          commit("UPDATE_CREATEPAYROLL", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllCreatePayroll({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/payroll/createpayroll")
        .then((response) => {
          commit("GET_ALL_CREATEPAYROLL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddUploadedLogHours({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/temp/loghours`, item.data, {
          params: {
            createPayrollId: item.createPayrollId,
            userId: item.userId,
          },
        })
        .then((response) => {
          commit("ADD_TEMPLOGHOURS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddUploadedOvertimeHours({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/temp/overtimehours", item.data, {
          params: {
            createPayrollId: item.createPayrollId,
            userId: item.userId,
          },
        })
        .then((response) => {
          commit("ADD_TEMPOVERTIMEHOURS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddUploadedEarnings({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/temp/earnings", item.data)
        .then((response) => {
          commit("ADD_TEMPEARNINGS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddUploadedDeductions({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/temp/deductions", item.data)
        .then((response) => {
          commit("ADD_TEMPDEDUCTIONS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddUploadedLoans({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/temp/loans", item.data)
        .then((response) => {
          commit("ADD_TEMPLOANS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllLogHoursByPayrollId({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/payroll/employeeloghoursByPayrollId/${item}`)
        .then((response) => {
          commit("GET_ALL_LOGHOURS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllLogHoursHistoryByPayrollId({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/payroll/employeeloghourshistoryByPayrollId/${item}`)
        .then((response) => {
          commit("GET_ALL_LOGHOURS_HISTORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllOvertimeByPayrollId({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/payroll/employeeOvertimeByPayrollId/${item}`)
        .then((response) => {
          commit("GET_ALL_OVERTIME", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllOvertime({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/payroll/employeeOvertime`)
        .then((response) => {
          commit("GET_ALL_OVERTIME", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllEarnings({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/payroll/employeeEarnings")
        .then((response) => {
          commit("GET_ALL_EARNINGS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllDeductions({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/payroll/employeeDeductions")
        .then((response) => {
          commit("GET_ALL_DEDUCTIONS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllLoans({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/payroll/employeeLoans")
        .then((response) => {
          commit("GET_ALL_LOANS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateEmployeeLogHours({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/payroll/employeeloghours", item)
        .then((response) => {
          commit("UPDATE_EMPLOYEELOGHOURS", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddEmployeeOvertime({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/payroll/employeeOvertime", item)
        .then((response) => {
          commit(
            "ADD_EMPLOYEEOVERTIME",
            Object.assign(item, { id: response.data.data.id })
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateEmployeeOvertime({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/payroll/employeeOvertime", item)
        .then((response) => {
          commit("UPDATE_EMPLOYEEOVERTIME", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteEmployeeOvertime({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/payroll/employeeOvertime/${item}`)
        .then((response) => {
          commit("DELETE_EMPLOYEEOVERTIME", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddEmployeeEarnings({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/payroll/employeeEarnings", item)
        .then((response) => {
          commit(
            "ADD_EMPLOYEEEARNINGS",
            Object.assign(item, { id: response.data.data.id })
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateEmployeeEarnings({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/payroll/employeeEarnings", item)
        .then((response) => {
          commit("UPDATE_EMPLOYEEEARNINGS", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteEmployeeEarnings({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/payroll/employeeEarnings/${item}`)
        .then((response) => {
          commit("DELETE_EMPLOYEEEARNINGS", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddEmployeeDeductions({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/payroll/employeeDeductions", item)
        .then((response) => {
          commit(
            "ADD_EMPLOYEEDEDUCTIONS",
            Object.assign(item, { id: response.data.data.id })
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateEmployeeDeductions({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/payroll/employeeDeductions", item)
        .then((response) => {
          commit("UPDATE_EMPLOYEEDEDUCTIONS", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteEmployeeDeductions({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/payroll/employeeDeductions/${item}`)
        .then((response) => {
          commit("DELETE_EMPLOYEEDEDUCTIONS", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddEmployeeLoans({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/payroll/employeeLoans", item)
        .then((response) => {
          commit(
            "ADD_EMPLOYEELOANS",
            Object.assign(item, { id: response.data.data.id })
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateEmployeeLoans({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/payroll/employeeLoans", item)
        .then((response) => {
          commit("UPDATE_EMPLOYEELOANS", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteEmployeeLoans({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/payroll/employeeLoans/${item}`)
        .then((response) => {
          commit("DELETE_EMPLOYEELOANS", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
